import React from 'react';
import { motion } from 'framer-motion';
import { Users2, Layers, Server, MapPin, ArrowRight } from 'lucide-react';
import { Section, SectionHeading } from '../ui/Section';
import { Button } from '../ui/Button';
const facts = [{
  icon: Users2,
  title: 'Who it is for',
  body: 'Law, accounting and other professional services firms, typically 30–100 seats.'
}, {
  icon: Layers,
  title: 'What CT Group manages',
  body: 'Infrastructure, software, licensing, users, support, security, hosting and voice.'
}, {
  icon: Server,
  title: 'Why the model is different',
  body: 'One accountable partner backed by CT Group-operated private cloud, server and data-centre infrastructure.'
}, {
  icon: MapPin,
  title: 'Where CT Group supports clients',
  body: 'Perth, Melbourne, Sydney, Brisbane and firms across Australia.'
}];
export function AnswerFirst() {
  return <Section className="bg-surface-2" ariaLabel="Positioning" data-id="element-126">
      <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-127">
        <div className="lg:sticky lg:top-32" data-id="element-128">
          <SectionHeading eyebrow="Managed IT services, plainly explained" title="An end-to-end technology partner — not just another MSP." body="CT Group takes responsibility for the technology your people use every day, bringing support, infrastructure, software, security, hosting and communications into one managed environment." data-id="element-129" />
          <div className="mt-8" data-id="element-130">
            <Button as="a" href="#difference" variant="navy" data-id="element-131">
              Explore the CT Group difference
              <ArrowRight className="h-4 w-4 transition-transform group-hover/btn:translate-x-0.5" aria-hidden data-id="element-132" />
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-133">
          {facts.map((f, i) => <motion.div key={f.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="group flex h-full flex-col rounded-card border border-border bg-white p-6 shadow-sm transition-all duration-300 ease-smooth hover:-translate-y-1 hover:shadow-md hover:border-border-strong" data-id="element-134">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-ct-cyan/10 ring-1 ring-ct-cyan/15" data-id="element-135">
                <f.icon className="h-[22px] w-[22px] text-ct-deep" aria-hidden data-id="element-136" />
              </span>
              <h3 className="mt-5 font-display text-[17px] font-bold text-navy" data-id="element-137">
                {f.title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-slate" data-id="element-138">
                {f.body}
              </p>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}